/********************************************
 * 公共方法、判断数组、数据去除空格等
 ********************************************/
import axios from 'axios'
axios.defaults.timeout = 600000;
export default {
  /**
   * 转换日期方法
   * **/
  formatDate: function (date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
      }
    }
    return fmt;
  },
  
  /**
   * 设置本地存储
   * **/
  setLocal: function (key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  /**
   * 读取本地存储
   * **/
  getLocal: function (key) {
    var data = localStorage.getItem(key);
    return JSON.parse(data);
  },
  /**
   * 存取本地存储-自动判断
   * **/
  localStorage: (data) => {
    let tmp = '';
    if (data && JSON.stringify(data) !== "{}") {
      localStorage.setItem("tmpData", JSON.stringify(data));
      tmp = data;
    } else {
      tmp = JSON.parse(localStorage.getItem("tmpData"));
    }
    return tmp;
  },
  isArray: function (object) {
    return object && typeof object === 'object' &&
      typeof object.length === 'number' &&
      typeof object.splice === 'function' &&
      //判断length属性是否是可枚举的 对于数组 将得到false
      !(object.propertyIsEnumerable('length'));
  },
  /**
  * 获取路径
  * **/
  getUrl: function () {
    return window.location.protocol + '//' + window.location.host;
  },
  /**
   * axios的get post 方法
   * **/
  axios: {
    http: async function (url, data = {}, type = 'get') {
      if (JSON.stringify(data).length < 3) { type = 'get'; } else { type = 'post'; }
      return new Promise((resolve, reject) => {
        axios({
          method: type,
          url: url,
          data: JSON.stringify(data)
        }).then(response => {
          resolve(response.data);
        }).catch(err => {
          reject(err);
        })
      })
    },
    put: async function (url, data = {}) {
      // if(JSON.stringify(data).length<3){type = 'get';}else{type = 'post';}
      return new Promise((resolve, reject) => {
        axios.put(url, data).then(response => {
          resolve(response.data);
        }).catch(err => {
          reject(err);
        })
      })
    },
    delete: async function (url, con = {}) {
      // if(JSON.stringify(data).length<3){type = 'get';}else{type = 'post';}
      return new Promise((resolve, reject) => {
        axios.delete(url, con).then(response => {
          resolve(response.data);
        }).catch(err => {
          reject(err);
        })
      })
    },
    /*axios的分页方法*/
    paging: function (page = 1) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: "/admin/news/news_list?page=" + page,
        }).then((response) => {
          resolve(response.data);
        }).catch(err => {
          reject(err)
        })
      })
    },
    /**
     * 验证密码是否过期
     * **/
    isValidate: function () {
      let validate = '', myAjax = new XMLHttpRequest();
      myAjax.withCredentials = true;
      myAjax.open('get', baseURL + '/user/validate', false);
      myAjax.send();
      if (myAjax.readyState == 4 && myAjax.status == 200) {
        validate = JSON.parse(myAjax.response).code;
      }
      return validate;
    },
  },
  /**
   * 显示和隐藏返回按钮
   */
  timer:'',
  showHideBtn(ele){
    let style=ele.querySelector(".btn-green").style.left;
    clearTimeout(this.timer);
    if(style=='0px'){
      ele.querySelector(".btn-green").style.left = '-15%';
    }else{
      ele.querySelector(".btn-green").style.left=0;
      this.timer = setTimeout(()=>{
        ele.querySelector(".btn-green").style.left = '-15%';
      }, 4000);
    }
  },
  // 判断各种浏览器，找到正确的方法 进入全屏
  launchFullscreen (element) {
    if (element.requestFullscreencreen) {
      element.requestFullScreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullScreen) {
      element.webkitRequestFullScreen();
    } else if (element.msRequestFullScreen) {
      element.msRequestFullScreen();
    }
  },
  // 判断浏览器种类 退出全屏
  exitFullscreen () {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen()
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen()
    }
  }

}
function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}




// WEBPACK FOOTER //
// ./src/api/publicFun.js